import { render, staticRenderFns } from "./Armeria.vue?vue&type=template&id=02f87935&scoped=true"
import script from "./Armeria.vue?vue&type=script&lang=js"
export * from "./Armeria.vue?vue&type=script&lang=js"
import style0 from "./Armeria.vue?vue&type=style&index=0&id=02f87935&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f87935",
  null
  
)

export default component.exports